import { z } from 'zod';

export const SSubscribeToChatwootIdentifierMessage = z.object({
  channel: z.string(),
  pubsub_token: z.string(),
  user_id: z.int().optional(),
  account_id: z.int().optional(),
});
export type TSubscribeToChatwootIdentifierMessage = z.infer<
  typeof SSubscribeToChatwootIdentifierMessage
>;
